/* unplugin-vue-components disabled */import { render } from "./UserListView.vue?vue&type=template&id=4bd64486&scoped=true"
import script from "./UserListView.vue?vue&type=script&lang=js"
export * from "./UserListView.vue?vue&type=script&lang=js"

import "./UserListView.vue?vue&type=style&index=0&id=4bd64486&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bd64486"]])

export default __exports__